// 全省征订数据趋势模块
const state = {
  day: [],      // 今日趋势数据
  week: [],     // 本周趋势数据
  semester: [], // 本学期趋势数据
  year: []      // 本年趋势数据
}

const mutations = {
  SET_DATA(state, data) {
    if (data) {
      state.day = Array.isArray(data.day) ? data.day : []
      state.week = Array.isArray(data.week) ? data.week : []
      state.semester = Array.isArray(data.semester) ? data.semester : []
      state.year = Array.isArray(data.year) ? data.year : []
    }
  },
  RESET_DATA(state) {
    state.day = []
    state.week = []
    state.semester = []
    state.year = []
  }
}

const getters = {
  // 获取指定时间维度的趋势数据
  getByPeriod: state => period => {
    return state[period] || []
  },
  // 所有时间维度数据
  allPeriods: state => ({
    day: state.day,
    week: state.week,
    semester: state.semester,
    year: state.year
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
